<div class="row">
  <div class="col-8 col-sm-6 col-lg">
    <p class="font-weight-bold" translate>CART_SUBTOTAL</p>
    <div class="col-12 col-lg-4 order-lg-2" *ngIf="enableDiscount">
      <lib-discount-input
        class="d-block"
        [(ngModel)]="discountCode"
        (discountDescription)="discountDescription = $event"
        (discountCode)="setDiscountCode($event)"
      ></lib-discount-input>
      <div
        class="alert alert-success position-absolute mt-n4"
        *ngIf="discountDescription && discountDescription.length > 0"
        style="z-index: 1"
      >
        {{ discountDescription | translate }}
      </div>
    </div>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm checkout-btn-previous"
      (click)="isFirstStep ? emptyCart() : prevClicked.emit()"
      translate
    >
      {{ isFirstStep ? 'EMPTY_CART' : prevBtnText }}
    </button>
  </div>
  <div class="col-4 col-sm-6 col-lg-2" style="display: flex; align-items: end; flex: 1">
    <lib-gung-select-option-input
      suppressLabel="true"
      [(ngModel)]="vatGst"
      (ngModelChange)="vatSelectOption($event)"
      [optionsList]="[
        { id: 'VAT', name: 'VAT' | translate },
        { id: 'GST', name: 'GST' | translate }
      ]"
    />
    @if (isVatSelected) {
      <lib-gung-number-input
        [gungTranslate]="'VAT_PRECENTAGE'"
        placeholder="0"
        [(ngModel)]="cartVat"
        (ngModelChange)="updateVat($event)"
      />
    } @else {
      <lib-gung-number-input
        [gungTranslate]="'GST_PERCENTAGE'"
        placeholder="0"
        [(ngModel)]="cartVat"
        (ngModelChange)="updateVat($event)"
      />
    }
  </div>
  <div class="col-6 col-lg-4">
    <div class="row align-items-end">
      <div class="col-12 col-md-6">
        <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="saveCart()" *ngIf="isFirstStep">
          {{ 'SAVE_CART' | translate }}
        </button>

        <button
          type="button"
          class="btn btn-outline-primary btn-sm w-100 btn-create-quotation mt-1"
          (click)="createQuotation()"
          *ngIf="isFirstStep && !isEndUser"
        >
          {{ 'CREATE_QUOTATION' | translate }}
        </button>
      </div>

      <div class="col-12 col-md-6">
        <span *ngIf="(isAdmin || hasRoleOrder) && checkNextBtnDisabled()" class="text-danger" translate
          ><b>*</b>BROCHURES_DECISION_NECESSARY</span
        >
        <button
          *ngIf="isAdmin || hasRoleOrder"
          class="btn btn-primary w-100 btn-sm mt-1 checkout-btn-next"
          type="button"
          (click)="nextClicked.emit()"
          [disabled]="checkNextBtnDisabled() || !hasRoleOrder"
        >
          <span translate>{{ nextBtnText }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="col-6 col-lg-2 font-weight-bold item-info text-primary text-right">
    @if (!isLastStep) {
    <span translate
      >TOTAL_BEFORE_DISCOUNT<lib-price [price]="cartTotalWithoutDiscountValue" [currency]="cartCurrency"></lib-price
    ></span>
      <div class="pt-1">
        <span translate
          >TOTAL_AFTER_DISCOUNT<lib-price [price]="cartTotalValue" [currency]="cartCurrency"></lib-price
        ></span>
      </div>
    } @else {
      <span translate>TOTAL_BEFORE_DISCOUNT<lib-price [price]="cartTotalNet" [currency]="cartCurrency"></lib-price></span>
    }
    @if (cartVat > 0) {
      <div class="pt-1">
        <span
          >{{ (isVatSelected ? 'VAT' : 'GST') | translate }}<span>: {{ cartVat }}</span
          ><span> %</span>
        </span>
      </div>
      <div class="pt-1">
        <span
          >{{ (isVatSelected ? 'VAT_VALUE' : 'GST_VALUE') | translate }}
          <span>: <lib-price [price]="cartVatValue" [currency]="cartCurrency" display="custom"></lib-price></span
        ></span>
      </div>
      <div class="pt-1 pb-2">
        <span
          >{{ (isVatSelected ? 'TOTAL_VAT_INCLUDED' : 'TOTAL_GST_INCLUDED') | translate }}
          <lib-price [price]="cartTotalWithVat" [currency]="cartCurrency"></lib-price
        ></span>
      </div>
    }
  </div>
</div>
